import { selectors } from './data'

// Backend
export function getDownloadEverything(state) {
    return selectors.backend.getDownloadEverything(state.settingsReducer)
}

export function getRunClientsWithLogging(state) {
    return selectors.backend.getRunClientsWithLogging(state.settingsReducer)
}

export function getRunClientsWithDx9(state) {
    return selectors.backend.getRunClientsWithDx9(state.settingsReducer)
}

export function getShouldMinimizeToTray(state) {
    return selectors.backend.getShouldMinimizeToTray(state.settingsReducer)
}

export function getLanguage(state) {
    return selectors.backend.getLanguage(state.settingsReducer)
}

export function getTestServers(state) {
    return selectors.backend.getTestServers(state.settingsReducer)
}

export function getBackendSettings(state) {
    return selectors.backend.getBackendSettings(state.settingsReducer)
}

export function getLauncherType(state) {
    return selectors.backend.getLauncherType(state.settingsReducer)
}

// UI
export function getLaunchDelay(state) {
    return selectors.ui.getLaunchDelay(state.settingsReducer)
}

export function getAutoLaunchOnLogin(state) {
    return selectors.ui.getAutoLaunchOnLogin(state.settingsReducer)
}

export function getAutoLaunchOnStartup(state) {
    return selectors.ui.getAutoLaunchOnStartup(state.settingsReducer)
}

export function getLayout(state) {
    return selectors.ui.getLayout(state.settingsReducer)
}

export function getUiSettings(state) {
    return selectors.ui.getUiSettings(state.settingsReducer)
}

// Localized
export function getText(state) {
    return selectors.localized.getText(state.settingsReducer)
}

// Servers
export function getServers(state) {
    return selectors.servers.getServers(state.settingsReducer)
}

// Display
export function getCounter(state) {
    return selectors.display.getCounter(state.settingsReducer)
}



// WEBPACK FOOTER //
// ./src/features/Settings/selectors.js